/**
 * Safe DOMPurify wrapper for the few places we render server-supplied HTML.
 *
 * We only need to render very small bits of markup (offer terms, benefit
 * strings that may contain <br> or <strong>). Anything more elaborate is
 * rendered as plain text. This wrapper defaults to a very tight allow-list.
 */
import DOMPurify from "dompurify";

const DEFAULT_ALLOWED_TAGS = [
  "b", "i", "em", "strong", "u", "br", "span", "small", "sup", "sub",
  "a", "p", "ul", "ol", "li",
];

const DEFAULT_ALLOWED_ATTR = ["href", "target", "rel", "class"];

export function sanitizeHtml(html, options = {}) {
  if (html == null) return "";
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS: options.tags || DEFAULT_ALLOWED_TAGS,
    ALLOWED_ATTR: options.attr || DEFAULT_ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}

/** Convenience: returns the `dangerouslySetInnerHTML` prop-shaped object. */
export function safeHtml(html, options = {}) {
  return { __html: sanitizeHtml(html, options) };
}
